import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const dateTimeFilterOperators = unreadonly([
  ...filterOperators.empty,
  ...filterOperators.dateTime,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type DateTimeFilterOperator = (typeof dateTimeFilterOperators)[number];

export type DateTimeTableFilter = TableFilterBase & {
  type: 'dateTime';
};

export const createDateTimeFilter = (): DateTimeTableFilter => ({
  type: 'dateTime',
  operators: dateTimeFilterOperators,
});
